<script>
import { Doughnut, mixins } from 'vue-chartjs';

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    options: { type: Object, default: () => ({}) },
    percentage: { type: Number, default: 100 }
  },
  computed: {
    circumference() {
      return (this.percentage * 2 * Math.PI) / 100;
    },
    rotation() {
      return (1 / 2) * Math.PI + (((2 * Math.PI) - this.circumference) / 2);
    },
    chartOptions() {
      return {
        circumference: this.circumference,
        rotation: this.rotation,
        ...this.options
      };
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};

</script>
